import React from 'react'
import { useQuery, UseQueryOptions } from 'react-query'
import { indexBy, pathOr, prop } from 'ramda'
import { ITimeRange } from './options.type'

// 投資回收期選單
export const usePaybackPeriod = (options?: UseQueryOptions<any>) => {
  const { data, isLoading, refetch } = useQuery<ITimeRange[]>(
    ['/systemAdmin/options/optionsPaybackPeriod'],
    {
      refetchOnMount: true,
      select: data => {
        return pathOr([], ['data'], data)
      },
      ...options,
    }
  )

  const byId = React.useMemo(() => {
    return data ? indexBy(prop('id'), data) : {}
  }, [data])

  return { data, isLoading, refetch, byId }
}

// 預計時效選單
export const useEstimatedTime = (options?: UseQueryOptions<any>) => {
  const { data, isLoading, refetch } = useQuery<ITimeRange[]>(
    ['/systemAdmin/options/optionsEstimatedTime'],
    {
      ...options,
      select: data => {
        return pathOr([], ['data'], data)
      },
    }
  )

  const byId = React.useMemo(() => {
    return data ? indexBy(prop('orderSeq'), data) : {}
  }, [data])

  return { data, isLoading, refetch, byId }
}
